import React from "react";
import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
  Menu,
  Segment
} from "semantic-ui-react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../store/actions/auth";

const CustomLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const authenticated = useSelector(state => state.auth.token !== null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/"); // redirect after logout
  };

  return (
    <div>
      {/* Example: show logout if authenticated */}
      {authenticated && (
        <Menu>
          <Menu.Item>
            <button onClick={handleLogout}>Logout</button>
          </Menu.Item>
        </Menu>
      )}
      {children}
    </div>
  );
};

export default CustomLayout;